import { useState, useContext, useEffect } from "react";
import { OverlayTrigger, Tooltip, Modal} from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../../../contexts/AuthContext";
import "./MensalidadesAdm.css";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import * as links from "../../../../../utils/links";
import moment from "moment";
import { Input, Button, Row } from "antd";
import checkImage from "../../../../../assets/images/image_check.png";
import MensalidadesTable from "../Table/MensalidadesTable";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SERVIDOR_URL } from "../../../../../utils/constants";

export default function MensalidadesAdm() {

  const location = useLocation();
  const clienteInfo = (location.state as any);

  const { setDataUser, authInfo} = useContext<any>(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const [diaDoPagamento, setDiaDoPagamento] = useState<any>("");
  const [paymentResponse, setPaymentResponse] = useState<any>("");
  const [numeroParcelas, setNumeroParcelas] = useState<any>("");
  const [valor, setValor] = useState<any>();
  const [loadingTable, setLoadingTable] = useState<any>(false);
  const [listMensals, setListMensals] = useState<any>([]);
  const [dataFim, setDataFim] = useState<any>(null);
  const [somaAtraso, setSomaAtraso] = useState<any>("");
  const [proximaParcela, setProximaParcela] = useState<any>("");
  const [dataVencimento, setDataVencimento] = useState<any>("");
  const [showModal, setShowModal] = useState<any>(false);  // Estado para controlar a visibilidade da modal
  const [copied, setCopied] = useState<any>(false);
  const [paymentStatus, setPaymentStatus] = useState<any>(false);
  const [paymentInterval, setPaymentInterval] = useState<any>(null);
  const [referenceId, setReferenceId] = useState<any>(null);

  const { id } = useParams();

  useEffect(() => {
    getData(id);
  }, []);




  const handleShowModal = () => setShowModal(true);  // Função para abrir a modal
  const handleCloseModal = () => setShowModal(false);  // Função para fechar a modal

  const checkPaymentStatus = (referenceId) => {
    axios
      .get(`${SERVIDOR_URL}/verificar-cobranca/${referenceId}`, {
        headers: {
          "x-access-token": dataUser?.token,
          "content-type": "application/json",
        },
      })
      .then((response) => {
        const isPaid = response?.data?.pago; // Verifique se 'pago' está em 'response.data'
        console.log(isPaid);
        setPaymentStatus(isPaid); // Atualiza o status do pagamento
  
        if (isPaid) {
          toast.success("Pagamento confirmado!");
          clearInterval(paymentInterval); // Para o intervalo de verificação
          setReferenceId(null); // Reseta a referência
        }
      })
      .catch((err) => {
        console.error("Erro ao verificar o pagamento:", err);
      });
  };
  
  useEffect(() => {
    if (referenceId) {
      // Inicia o intervalo para checar o pagamento a cada 5 segundos
      const interval = setInterval(() => {
        checkPaymentStatus(referenceId);
      }, 5000);
  
      setPaymentInterval(interval); // Armazena o intervalo em estado
  
      // Limpeza do intervalo ao desmontar o componente
      return () => clearInterval(interval);
    }
  }, [referenceId]);

  useEffect(() => {
    if (paymentStatus) {
      const timeout = setTimeout(() => {
        handleCloseModal();
      }, 8000);
      getData(id);
      return () => clearTimeout(timeout);
    }
  }, [paymentStatus]);




  const generatePayments = (diaDoPagamento, numeroParcelas, valor) => {
    let body = {
      diaDoPagamento: formatarParaMoeda(diaDoPagamento),
      numeroDeParcelas: formatarParaMoeda(numeroParcelas),
      valor: formatarParaMoeda(valor),
      clienteId: id
    }
      axios.post(`${SERVIDOR_URL}/gerarPagamentosParaCliente`,body,{
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }).then((res) => {
        toast.success(`${res.data.message}`);
        getData(id);
      }).catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          toast.error("A sua sessão expirou, para continuar faça login novamente.")
          if(dataUser.key === 'ADMIN'){
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          }else{
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        }
        toast.error(`${err?.response?.data?.error}`)
      });
    }

  const generatePayment = (id) => {
      axios.post(`${SERVIDOR_URL}/gerar-cobranca/${id}`,{
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }).then((res) => {
        setPaymentStatus(false);
        setPaymentResponse(res?.data);
        setReferenceId(res?.data?.payment_data?.external_reference);
        toast.success(`${res.data.status}`);
        handleShowModal();
      }).catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          toast.error("A sua sessão expirou, para continuar faça login novamente.")
          if(dataUser.key === 'ADMIN'){
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          }else{
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        }
        toast.error(`${err?.response?.data?.error}`);
      });
    }

  const updateTable = () =>{
    getData(id);

  }

  const getData = (id) => {
    if (id.trim() !== "") {
      setLoadingTable(true);
      axios
        .get(`${SERVIDOR_URL}/parcelas?clienteId=${id}`, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          setLoadingTable(false);
          setSomaAtraso(res?.data?.somaAtraso);
          setProximaParcela(res?.data?.proximaParcela);
          setDataVencimento(res?.data?.dataVencimento);
          if (res.status === 200 && Array.isArray(res.data.parcelas)) {
            setListMensals(res.data.parcelas);
          }
        })
        .catch((err) => {
          setLoadingTable(false);
          if ([401, 403].includes(err.response.status)) {
            toast.error("A sua sessão expirou, para continuar faça login novamente.")
            if(dataUser.key === 'ADMIN'){
              navigate(links.ADMIN_SIGNIN)
              setDataUser(null);
            }else{
              navigate(links.SIGNIN)
              setDataUser(null);
            }
          }
        });
    }
  };

  const formatarParaMoeda = (value) => {
    if (!value) return "";
    let valorNumerico = value.replace('R$','').replace(',','.');
    let valorFloat = parseFloat(valorNumerico.trim());
    return valorFloat;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(paymentResponse?.qr_code)
        .then(() => setCopied(true))
        .catch(err => console.error('Erro ao copiar para a área de transferência: ', err));
};

  return (
    <div className="px-page">
      <div className="px-page-header">
        <h1 className="px-page-title">Cliente: {clienteInfo?.nome}</h1>
        <button
          className="px-back-btn"
          onClick={() =>
            navigate(`${links.CLIENTES_MAQUINAS}/${clienteInfo?.id}`, {
              state: clienteInfo,
            })
          }
        >
          VOLTAR
        </button>
      </div>

      <div className="px-toolbar" style={{ marginBottom: 18 }}>
        <div style={{ minWidth: 170, flex: "1 1 170px" }}>
          <Input
            style={{
              textAlign: 'center',
              width: '100%',

              padding: '12px',
              fontSize: '16px',
            }}
            placeholder="Dia do vencimento"
            value={diaDoPagamento}
            id="diaDoPagamento"
            type="number"
            name="diaDoPagamento"
            min="1"
            max="31"
            onChange={(event) => {
              let value = event.target.value;
              if (value === '' || (Number(value) >= 1 && Number(value) <= 31)) {
                setDiaDoPagamento(value);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === '+') {
                e.preventDefault();
              }
            }}
          />
        </div>
        <div style={{ minWidth: 170, flex: "1 1 170px" }}>
          <Input
            style={{
              textAlign: 'center',
              width: '100%',
              padding: '12px',
              fontSize: '16px',
            }}

            placeholder="Número de Parcelas"
            value={numeroParcelas}
            id="numeroParcelas"
            type="number"
            name="numeroParcelas"
            min="1"
            max="12"
            onChange={(event) => {
              let value = event.target.value;
              if (value === '' || (Number(value) >= 1 && Number(value) <= 12)) {
                setNumeroParcelas(value);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === '+') {
                e.preventDefault();
              }
            }}
          />
        </div>
        <div style={{ minWidth: 170, flex: "1 1 170px" }}>
          <Input
            style={{
              textAlign: 'center',
              width: '100%',
              padding: '12px',
              fontSize: '16px',
            }}
            placeholder="R$ Valor"
            value={valor}
            id="valor"
            type="text"
            name="valor"
            autoComplete="valor"
            onChange={(event) => {
              let value = event.target.value;
              value = value.replace(/\D/g, '');
              const formattedValue = ((value as any) / 100).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
              setValor(formattedValue);
            }}
          />
        </div>
        <button
          className="px-btn px-btn-primary"
          disabled={!diaDoPagamento || !numeroParcelas || !valor}
          onClick={() =>
            generatePayments(diaDoPagamento, numeroParcelas, valor)
          }
        >
          Gerar Mensalidades
        </button>
      </div>

      <div className="px-stat-grid">
        <div className="px-stat-card">
          <div>
            <h6 className="px-stat-label">Data de Vencimento</h6>
            <h5 className="px-stat-value">
              {moment(dataVencimento).add(3, 'hours').format("DD/MM/YYYY")}
            </h5>
          </div>
        </div>
        <div className="px-stat-card">
          {
            somaAtraso > 0 ?
            <div>
              <h6 className="px-stat-label">Total de Débitos</h6>
              <h5 className="px-stat-value">
                {Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(somaAtraso)}
              </h5>
            </div>
            :
            proximaParcela ?
            <div>
              <h6 className="px-stat-label">Próxima Parcela</h6>
              <h5 className="px-stat-value">
                {Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(proximaParcela)}
              </h5>
            </div>
            :
            <div>
              <h6 className="px-stat-label">Nenhum Débito</h6>
              <h5 className="px-stat-value">
                Sem parcelas a pagar
              </h5>
            </div>
          }
          {
            somaAtraso !== 0 || proximaParcela && (
            <button
              disabled={somaAtraso === 0 && !proximaParcela}
              className="px-btn px-btn-primary"
              onClick={() =>
                generatePayment(id)
              }
            >
              Pagar
            </button>
            )
          }
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} centered style={{ textAlign: 'center' }}>
        <Modal.Header closeButton className="modal-footer">
          <Modal.Title>Valor: {somaAtraso > 0 ? Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(somaAtraso) : Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(proximaParcela)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {paymentStatus ? (
            <img
              src={checkImage}
              alt="Pagamento Concluído"
              className="qr-code"
            />
          ) : paymentResponse?.qr_code ? (
            <img
              src={`data:image/png;base64,${paymentResponse?.qr_code_base64.replace(/"/g, '')}`}
              alt="QR Code"
              className="qr-code"
            />
          ) : (
            <p>QR Code não disponível.</p>
          )}
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          { paymentStatus ? 
            <button className="px-btn px-btn-primary" style={{ width: '100%' }}
            >
              Pagamento Confirmado</button>
              :
            <button className="px-btn px-btn-primary" style={{ width: '100%' }} onClick={handleCopy}
            >
              <i className="bi bi-copy" style={{marginRight: '5px'}}></i>{copied ? 'Código copiado!' : 'Copiar código'}</button>
          }
        </Modal.Footer>
      </Modal>
      {/* Tabela */}
      <div className="px-panel">
        <div className="px-panel-header">
          <h5 className="px-panel-title">Mensalidades</h5>
        </div>
        <div className="px-panel-body">
          <MensalidadesTable updateTable={updateTable} listMensals={listMensals}/>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
}